// src/components/Layout/Footer.tsx

import { FC } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import styles from '../../css/Footer.module.css';
import { Linkedin, Twitter, ArrowUpRight } from 'lucide-react';

const Footer: FC = () => {
    const currentYear = new Date().getFullYear();

    const iconVariants = {
        hover: { y: -3, color: "#ffffff", transition: { duration: 0.2 } }
    };

    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                
                {/* Top Section: Navigation & Brand */}
                <div className={styles.footerGrid}>
                    
                    {/* Brand Column */}
                    <div className={styles.brandColumn}>
                        <h3 className={styles.brandName}>OTA TECH Inc.</h3>
                        <p className={styles.brandTagline}>
                            Engineering the foundations of <br /> tomorrow's business logic.
                        </p>
                        <div className={styles.socialLinks}>
                            <motion.a 
                                href="#" 
                                aria-label="LinkedIn" 
                                target="_blank" 
                                rel="noreferrer"
                                variants={iconVariants}
                                whileHover="hover"
                            >
                                <Linkedin size={20} />
                            </motion.a>
                            <motion.a 
                                href="#" 
                                aria-label="Twitter" 
                                target="_blank" 
                                rel="noreferrer"
                                variants={iconVariants}
                                whileHover="hover"
                            >
                                <Twitter size={20} />
                            </motion.a>
                        </div>
                    </div>

                    {/* Navigation Columns */}
                    <div className={styles.navGroup}>
                        <h4 className={styles.groupTitle}>Company</h4>
                        <Link to="/about" className={styles.link}>About Us</Link>
                        <Link to="/careers" className={styles.link}>Careers</Link>
                        <Link to="/contact" className={styles.link}>Contact</Link>
                        <Link to="/investors" className={styles.link}>Investors</Link>
                    </div>
                    
                    <div className={styles.navGroup}>
                        <h4 className={styles.groupTitle}>Ventures</h4>
                        <Link to="/portfolio" className={styles.link}>Portfolio Overview</Link>
                        <a 
                            href="https://www.ota-erp.com" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className={styles.externalLink}
                        >
                            OTA ERP <ArrowUpRight size={12} />
                        </a>
                        <span className={styles.disabledLink}>Project SUIT (Beta)</span>
                    </div>

                    <div className={styles.navGroup}>
                        <h4 className={styles.groupTitle}>Legal</h4>
                        <Link to="/terms" className={styles.link}>Terms of Service</Link>
                        <Link to="/privacy" className={styles.link}>Privacy Policy</Link>
                        <Link to="/compliance" className={styles.link}>Compliance</Link>
                    </div>
                </div>

                {/* Bottom Section: Copyright & Info */}
                <div className={styles.footerBottom}>
                    <div className={styles.separator}></div>
                    <div className={styles.bottomContent}>
                        <p className={styles.copyright}>
                            © {currentYear} OTA TECH Inc. Delaware C-Corp.
                        </p>
                        <p className={styles.address}>
                            Wilmington, DE • Accra, GH
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;